import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../routes/paths";

export function StatusCell({ dataItem }) {
  return (
    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
      {dataItem.isActive ? "Active" : "Inactive"}
    </td>
  );
}

export function ActionCell({ dataItem, onDelete }) {
  const navigate = useNavigate();

  return (
    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
      <button
        type="button"
        onClick={() => navigate(`${Paths.editEscalationMatrix}/${dataItem.id}`)}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          padding: 2,
          marginRight: 8,
        }}
      >
        <FaEdit color="var(--primary-dark)" size={16} />
      </button>

      <button
        type="button"
        onClick={() => onDelete(dataItem.id)}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          padding: 2,
        }}
      >
        <FaTrash color="red" size={16} />
      </button>
    </td>
  );
}
